// import { LocalStorage, Notify } from 'quasar'

function calcCant (obj) {
  let count = 0
  for (let c in obj) {
    count++
  }
  // return count
  return count
}
function total (cart) {
  var totalPrice = 0
  for (const key in cart) {
    totalPrice += (cart[key].price * cart[key].quantity)
  }
  return totalPrice
}

export function addToCart ( { commit }, payload) {
//   console.log(payload);

	if(LocalStorage.has('cart')){
    const currentCart = LocalStorage.getItem('cart')
    currentCart[payload.id] = payload

    LocalStorage.set('cart', currentCart)
    commit('changeCart', currentCart)
    commit('changeCount', calcCant(currentCart))
    commit('changeTotal', total(currentCart))
    Notify.create({
      message: 'Producto añadido al carrito.',
      position: 'top',
      color: 'purple'
    })
    // const notEmtry  = payload.filter( ({ quantity }) => quantity !== 0 )
		// const currentCart = LocalStorage.getItem('cart')

		// for(let item of notEmtry) {
    //   currentCart[item.id] = item
    // }

		// LocalStorage.set('cart', currentCart)
    // commit('changeCart', currentCart)
    // commit('changeCount', calcCant(currentCart))
    // commit('changeTotal', total(currentCart))
	} else {
    const tmp1 = {}
    tmp1[payload.id] = payload

    // LocalStorage.set('cart', tmp1)
    // LocalStorage.set('company', payload[1])
    // commit('changeCart', tmp1)
    // commit('changeCount', calcCant(tmp1))
    // commit('changeTotal', total(tmp1))
    // Notify.create({
    //   message: 'Se agrego los productos correctamente al carrito.',
    //   icon: 'shopping_cart',
    //   position: 'top',
    // })

    // const notEmtry = payload.filter( ({ quantity }) => quantity !== 0 )
    // const tmp1 = {}

    // for (let index = 0; index < notEmtry.length; index++) {
    //   tmp1[payload[index].id] = payload[index]
    //   console.log('añadir')
    // }

    LocalStorage.set('cart', tmp1)
    commit('changeCart', tmp1)
    commit('changeCount', calcCant(tmp1))
    commit('changeTotal', total(tmp1))
    Notify.create({
      message: 'Producto añadido al carrito.',
      position: 'top',
      color: 'purple'
    })
  }
  // Notify.create({
  //   message: 'Producto añadido al carrito.',
  //   position: 'top',
  //   color: 'purple'
  // })
}
export function updateItem ({ commit }, opt) {
  const cart = LocalStorage.getItem('cart')
  cart[opt.id].quantity = opt.quantity

  LocalStorage.set('cart', cart)
  commit('changeCart', cart)
  commit('changeTotal', total(cart))
}
export function removeItem ({ commit }, opt) {
  const cart = LocalStorage.getItem('cart')
  const newCart = {}
  for (var [key, value] of Object.entries(cart)) {
    // if (opt.itemId !== parseInt(key, 10)) {
    if (opt.itemId.toString() !== key) {
      newCart[key] = value
    }
  }

  LocalStorage.set('cart', newCart)
  commit('changeCart', newCart)
  commit('changeCount', calcCant(newCart))
  commit('changeTotal', total(newCart))
  Notify.create({
    message: 'Producto quitado del carrito.',
    position: 'top'
  })
}
export function removeCart ({ commit }) {
  commit('removeAll')
}
